import GameItem from "./GameItem";
import { useSelector } from "react-redux";

function GamesList() {
  const { games, gamesLoading, currentCategoryId } = useSelector((state) => state.catalog);

  return (
    <div className={`games-list ${gamesLoading ? 'is-loading' : ''}`}>
      {games.map((item, index) => <GameItem key={`${currentCategoryId ?? 0}-${item.id}`} game={item} />)}
    </div>
  )
}

export default GamesList;
